/* Heaven Bound Collection — interactive layer for Plain Jane */
(function () {
  'use strict';
  var S = window.HB || {};
  var d = document;
  var root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (d.readyState !== 'loading') fn();
    else d.addEventListener('DOMContentLoaded', fn);
  }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  /* ---------- 1. Homepage halo ---------- */
  function initHalo() {
    if (!S.intro || !d.body.classList.contains('template-index')) return;
    var link = d.querySelector('.main-menu .logo-link');
    if (!link) return;
    link.classList.add('hb-logo');

    var halo = d.createElement('span');
    halo.className = 'hb-halo';
    halo.setAttribute('aria-hidden', 'true');
    halo.innerHTML = '<svg viewBox="0 0 200 60"><ellipse cx="100" cy="30" rx="92" ry="22" pathLength="1"/></svg>';
    link.insertBefore(halo, link.firstChild);

    var logo = link.querySelector('.logo');
    function light_up() {
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('hb-lit'); }); });
    }
    if (logo && !logo.complete) {
      logo.addEventListener('load', light_up, { once: true });
      logo.addEventListener('error', light_up, { once: true });
      setTimeout(light_up, 1500); // never leave the logo hidden
    } else {
      light_up();
    }

    if (!S.follow || !fine || reduce) return;
    var raf = 0, px = 0, py = 0;
    window.addEventListener('pointermove', function (e) {
      px = e.clientX; py = e.clientY;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = window.innerWidth, h = window.innerHeight;
        var r = link.getBoundingClientRect();
        var dx = (px - (r.left + r.width / 2)) / w;
        var dy = (py - (r.top + r.height / 2)) / h;
        halo.style.setProperty('--hb-tx', (dx * 30).toFixed(2) + 'deg');
        halo.style.setProperty('--hb-ty', (dy * -24).toFixed(2) + 'deg');
      });
    }, { passive: true });
  }


  /* ---------- 1b. The lamp: cursor reveals hidden scripture ---------- */
  /* "For our conversation is in heaven; from whence also we look for the Saviour, the Lord Jesus Christ: Who shall change our vile body, that it may be fashioned like unto his glorious body, according to the working whereby he is able even to subdue all things unto himself." */
  function initLamp() {
    if (!S.lamp || !d.body.classList.contains('template-index')) return;
    var verse = (S.verse || '').trim();
    if (!verse) return;
    var ref = (S.verseRef || '').trim();

    var layer = d.createElement('div');
    layer.className = 'hb-lamp';
    layer.setAttribute('aria-hidden', 'true');
    var text = d.createElement('p');
    var unit = verse + (ref ? ' \u2014 ' + ref : '') + ' \u00A0\u2726\u00A0 ';
    text.textContent = new Array(40).join(unit); // fill the screen
    layer.appendChild(text);
    d.body.appendChild(layer);

    // Start the lamp resting on the logo
    var logo = d.querySelector('.main-menu .logo-link');
    var r0 = logo ? logo.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 3, width: 0, height: 0 };
    var x = r0.left + r0.width / 2, y = r0.top + r0.height / 2, tx = x, ty = y, running = false;
    function apply() {
      layer.style.setProperty('--hb-lx', x.toFixed(1) + 'px');
      layer.style.setProperty('--hb-ly', y.toFixed(1) + 'px');
    }
    apply();
    requestAnimationFrame(function () { layer.classList.add('is-on'); });
    if (reduce) return;

    function tick() {
      x += (tx - x) * 0.14; // eased so it trails like a carried lantern
      y += (ty - y) * 0.14;
      apply();
      if (Math.abs(tx - x) > 0.5 || Math.abs(ty - y) > 0.5) requestAnimationFrame(tick);
      else running = false;
    }
    function move(px, py) {
      tx = px; ty = py;
      if (!running) { running = true; requestAnimationFrame(tick); }
    }
    window.addEventListener('pointermove', function (e) { move(e.clientX, e.clientY); }, { passive: true });
    window.addEventListener('touchmove', function (e) { var t = e.touches[0]; move(t.clientX, t.clientY); }, { passive: true });
  }

  /* ---------- 2. Shop grid cards ---------- */
  function initCards() {
    $all('.collection-item .link-block-2').forEach(function (a) { a.classList.add('hb-card'); });
    if (!S.hoverSwap || !fine) return;
    // Warm the second image the first time a card is approached
    $all('.hb-card .hb-alt').forEach(function (img) {
      var card = img.closest('.hb-card');
      card.addEventListener('pointerenter', function () {
        if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
      }, { once: true });
    });
  }

  /* ---------- 3. Product gallery ---------- */
  function initGallery() {
    if (!S.gallery) return;
    var main = d.querySelector('.product-image-main');
    if (!main) return;

    var wrap = d.createElement('div');
    wrap.className = 'hb-zoom';
    main.parentNode.insertBefore(wrap, main);
    wrap.appendChild(main);
    wrap.setAttribute('role', 'button');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('aria-label', 'Open full-size photo');

    function sources() {
      var list = [main.currentSrc || main.src];
      $all('.additional-photos .additional-image').forEach(function (i) {
        var s = i.currentSrc || i.src;
        if (s && list.indexOf(s) === -1 && !/\{#/.test(s)) list.push(s);
      });
      return list;
    }

    // Thumbnails swap into the main slot
    $all('.additional-photos .additional-image').forEach(function (thumb) {
      thumb.setAttribute('tabindex', '0');
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('aria-label', 'Show this photo');
      function swap() {
        var next = thumb.currentSrc || thumb.src;
        if (!next || next === main.src) return;
        wrap.classList.add('is-swapping');
        setTimeout(function () {
          main.removeAttribute('srcset');
          main.src = next;
          wrap.classList.remove('is-swapping');
        }, reduce ? 0 : 200);
        $all('.additional-image.is-active').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (window.innerWidth < 768) wrap.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
      thumb.addEventListener('click', swap);
      thumb.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); swap(); } });
    });

    // Hover zoom (desktop)
    if (fine && !reduce) {
      wrap.addEventListener('pointermove', function (e) {
        var r = wrap.getBoundingClientRect();
        wrap.style.setProperty('--hb-zx', ((e.clientX - r.left) / r.width * 100) + '%');
        wrap.style.setProperty('--hb-zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
      wrap.addEventListener('pointerenter', function () { wrap.classList.add('is-zooming'); });
      wrap.addEventListener('pointerleave', function () { wrap.classList.remove('is-zooming'); });
    }

    // Lightbox
    var lb = d.createElement('div');
    lb.className = 'hb-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product photos');
    lb.innerHTML =
      '<img alt="">' +
      '<button type="button" class="hb-lb-close" aria-label="Close">Close</button>' +
      '<button type="button" class="hb-lb-prev" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="hb-lb-next" aria-label="Next photo">&#8250;</button>' +
      '<div class="hb-lb-count" aria-live="polite"></div>';
    d.body.appendChild(lb);
    var lbImg = lb.querySelector('img'), count = lb.querySelector('.hb-lb-count');
    var list = [], idx = 0, lastFocus = null;

    function show(i) {
      idx = (i + list.length) % list.length;
      lbImg.src = list[idx];
      lbImg.alt = main.alt || '';
      count.textContent = list.length > 1 ? (idx + 1) + ' of ' + list.length : '';
      lb.querySelector('.hb-lb-prev').hidden = lb.querySelector('.hb-lb-next').hidden = list.length < 2;
    }
    function open() {
      list = sources();
      lastFocus = d.activeElement;
      show(0);
      lb.classList.add('is-open');
      d.body.style.overflow = 'hidden';
      lb.querySelector('.hb-lb-close').focus();
    }
    function close() {
      lb.classList.remove('is-open');
      d.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    wrap.addEventListener('click', open);
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    lb.querySelector('.hb-lb-close').addEventListener('click', close);
    lb.querySelector('.hb-lb-prev').addEventListener('click', function () { show(idx - 1); });
    lb.querySelector('.hb-lb-next').addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    d.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'Tab') { // keep focus inside
        var f = $all('button:not([hidden])', lb), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    var sx = null;
    lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) show(idx + (dx < 0 ? 1 : -1));
    });
  }

  /* ---------- 4. Add-to-cart feedback ---------- */
  function initCartFeedback() {
    if (!S.cartToast) return;
    var counts = $all('.w-commerce-commercecartopenlinkcount');
    if (!counts.length) return;

    var toast = d.createElement('div');
    toast.className = 'hb-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<span>' + (S.addedText || 'Added to cart') + '</span><button type="button">View cart</button>';
    d.body.appendChild(toast);
    var timer;
    toast.querySelector('button').addEventListener('click', function () {
      toast.classList.remove('is-shown');
      var opener = d.querySelector('[data-node-type="commerce-cart-open-link"]');
      if (opener) opener.click(); else window.location.href = '/cart';
    });

    function num(el) { return parseInt(el.textContent, 10) || 0; }
    var last = Math.max.apply(null, counts.map(num));

    function onChange() {
      var now = Math.max.apply(null, counts.map(num));
      if (now > last) {
        counts.forEach(function (c) {
          c.classList.remove('hb-bump'); void c.offsetWidth; c.classList.add('hb-bump');
        });
        toast.classList.add('is-shown');
        clearTimeout(timer);
        timer = setTimeout(function () { toast.classList.remove('is-shown'); }, 4000);
        var btn = d.querySelector('[data-node-type="commerce-add-to-cart-button"]');
        if (btn && btn.dataset.hbLabel === undefined) {
          btn.dataset.hbLabel = btn.value;
          btn.value = 'Added';
          setTimeout(function () { btn.value = btn.dataset.hbLabel; delete btn.dataset.hbLabel; }, 1800);
        }
      }
      last = now;
    }
    var mo = new MutationObserver(onChange);
    counts.forEach(function (c) { mo.observe(c, { childList: true, characterData: true, subtree: true }); });
  }

  /* ---------- 5. Prefetch pages on hover ---------- */
  function initPrefetch() {
    if (!S.prefetch) return;
    var done = {};
    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    function prefetch(e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.origin !== location.origin || a.hash && a.pathname === location.pathname) return;
      if (/\/(cart|checkout|account)/.test(a.pathname) || done[a.href]) return;
      done[a.href] = 1;
      var l = d.createElement('link');
      l.rel = 'prefetch'; l.href = a.href;
      d.head.appendChild(l);
    }
    d.addEventListener('pointerover', prefetch, { passive: true });
    d.addEventListener('touchstart', prefetch, { passive: true });
  }

  ready(function () {
    [initHalo, initLamp, initCards, initGallery, initCartFeedback, initPrefetch].forEach(function (fn) {
      try { fn(); } catch (err) { if (window.console) console.warn('[HeavenBound]', err); }
    });
  });
})();
